import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import ChapterList from "./components/ChapterList";
import ChapterView from "./components/ChapterView";
import Navigation from "./components/Navigation";
import Debate from "./components/Debate";
import Support from "./components/Support";
import TopicalResults from "./components/TopicalResults";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import About from "./components/About";

function InitialRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/debate");
  }, [navigate]);

  return null;
}

function ReadRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/read/book/Genesis/chapter/1");
  }, [navigate]);

  return null;
}

function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navigation />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "background.default",
          color: "text.primary",
        }}
      >
        <Routes>
          <Route path="/" element={<InitialRedirect />} />
          <Route path="/read" element={<ReadRedirect />} />
          <Route path="/about" element={<About />} />
          <Route path="/read/book/:bookId" element={<ChapterList />} />
          <Route
            path="/read/book/:bookId/chapter/:chapterNumber"
            element={<ChapterView />}
          />
          <Route
            path="/read/book/:bookId/chapter/:chapterNumber/verse/:verseNumber"
            element={<ChapterView />}
          />
          <Route path="/read/topical" element={<TopicalResults />} />
          <Route path="/debate" element={<Debate />} />
          <Route path="/support" element={<Support />} />
          <Route path="/redirect" element={<InitialRedirect />} />
        </Routes>
      </Box>
    </Box>
  );
}

function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <LanguageProvider>
        <Router>
          <AppContent />
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
